module.exports = __webpack_public_path__ + "static/media/builtinv2-Videonab 2.f36cbb43.png";